import config from "../../../config";
import { FlightReportRecipients, ListType } from "./reducer";

import {
  FLIGHT_REPORT_FETCH_RECIPIENTS_PENDING,
  FLIGHT_REPORT_FETCH_RECIPIENTS_FULFILLED,
  FLIGHT_REPORT_FETCH_RECIPIENTS_REJECTED,
  FLIGHT_REPORT_UPDATE_RECIPIENTS_PENDING,
  FLIGHT_REPORT_UPDATE_RECIPIENTS_FULFILLED,
  FLIGHT_REPORT_UPDATE_RECIPIENTS_REJECTED,
  FLIGHT_REPORT_WAS_RESET,
  QC_LIST_TYPE,
  GCP_LIST_TYPE,
} from "./reducer";
import { AppDispatch } from "../../../store";
import { siteContextRequest } from "../../siteContextRequest";

export const loadRecipients = (customerId: string, siteId: string) => (
  dispatch: AppDispatch,
): Promise<void> => {
  dispatch({ type: FLIGHT_REPORT_WAS_RESET, payload: null });
  dispatch({ type: FLIGHT_REPORT_FETCH_RECIPIENTS_PENDING });

  return dispatch(sendFetchRecipientsRequest(customerId, siteId)).then(
    ({ qcRecipientsList, gcpRecipientsList }) => {
      const recipients = {
        [QC_LIST_TYPE]: qcRecipientsList,
        [GCP_LIST_TYPE]: gcpRecipientsList,
      };
      dispatch({
        type: FLIGHT_REPORT_FETCH_RECIPIENTS_FULFILLED,
        payload: recipients,
      });
    },
    error => {
      dispatch({
        type: FLIGHT_REPORT_FETCH_RECIPIENTS_REJECTED,
        payload: error,
      });
      throw error;
    },
  );
};

const sendFetchRecipientsRequest = (customerId: string, siteId: string) => (
  dispatch: AppDispatch,
) =>
  dispatch(
    siteContextRequest(customerId, siteId, {
      method: "GET",
      url: `${config.endpoints.braApi}/api/v1/mailing-lists/customers/${customerId}/sites/${siteId}`,
    }),
  ).then(
    ({ data }) => Promise.resolve(data),
    (err: Error) => Promise.reject(err),
  );

export const updateRecipients = (
  customerId: string,
  siteId: string,
  recipients: FlightReportRecipients,
) => (dispatch: AppDispatch): Promise<FlightReportRecipients> => {
  dispatch({ type: FLIGHT_REPORT_UPDATE_RECIPIENTS_PENDING });

  return dispatch(
    sendUpdateRecipientsRequest(customerId, siteId, recipients),
  ).then(
    () => {
      dispatch({
        type: FLIGHT_REPORT_UPDATE_RECIPIENTS_FULFILLED,
        payload: recipients,
      });
      dispatch({
        type: FLIGHT_REPORT_FETCH_RECIPIENTS_FULFILLED,
        payload: recipients,
      });
      return recipients;
    },
    error => {
      dispatch({
        type: FLIGHT_REPORT_UPDATE_RECIPIENTS_REJECTED,
        payload: error,
      });
      throw error;
    },
  );
};

type MailingRecipientsResponse = {
  customerId: string;
  siteId: string;
  gcpRecipientsList: string[];
  qcRecipientsList: string[];
};

const sendUpdateRecipientsRequest = (
  customerId: string,
  siteId: string,
  recipients: FlightReportRecipients,
) => (dispatch: AppDispatch): Promise<MailingRecipientsResponse> =>
  dispatch(
    siteContextRequest(customerId, siteId, {
      method: "POST",
      url: `${config.endpoints.braApi}/api/v2/mailing-lists/customers/${customerId}/sites/${siteId}`,
      data: {
        qcRecipientsList: recipients.QC,
        gcpRecipientsList: recipients.GCP,
      },
    }),
  ).then(
    ({ data: { recipients } }) => Promise.resolve(recipients),
    (err: Error) => Promise.reject(err),
  );
